import ExTable, {ColumnDef, FilterDef, FilterOperator} from "../../components/ExTable";
import {useTranslation} from "react-i18next";
import {IdListRequest, useOrganizationDKVCustomerNumberListQuery} from "../../app/api/api";
import {DkvCustomerNumber, DkvCustomerNumberField} from "../../app/api/model/organization";
import {IconButton, Tooltip} from "@mui/material";
import React, {useState} from "react";
import DKVCustomerNumberCreateDialog from "./DKVCustomerNumberCreateDialog";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {getFormattedAddress} from "../../utils/getFormattedAddress";
import {TFunction} from "i18next";
import {usePermission} from "../../hooks/usePermission";
import {PermissionLevel} from "../../app/api/model/user";

const getColumnDefs = (t: TFunction): ColumnDef<DkvCustomerNumber>[] => [
    {
        fieldName: DkvCustomerNumberField.DKV_CUSTOMER_NUMBER,
        align: "left",
        label: t("organizations_dkvCustomerNumber"),
        width: 200,
        sortable: false,
    },
    {
        fieldName: DkvCustomerNumberField.T4E_ID,
        align: "left",
        label: t("dkvCustomerNumber_t4eId"),
        sortable: false,
    },
    {
        fieldName: DkvCustomerNumberField.NAME,
        align: "left",
        label: t("generic_name"),
        width: 200,
        sortable: false,
    },
    {
        fieldName: DkvCustomerNumberField.EMAIL,
        align: "left",
        label: t("generic_email"),
        sortable: false,
    },
    {
        fieldName: DkvCustomerNumberField.ADDRESS,
        align: "left",
        label: t("generic_address"),
        sortable: false,
        formatCellText: ({cellValue}) => getFormattedAddress(t, cellValue),
    },
];

export default function DKVCustomerNumberTable({organizationId}: {organizationId: number}) {
    const {t} = useTranslation();
    const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
    const {hasPermission} = usePermission();

    const filterDefs: FilterDef<DkvCustomerNumber>[] = [
        {
            fieldName: DkvCustomerNumberField.DKV_CUSTOMER_NUMBER,
            filterOperators: [FilterOperator.CONTAINS, FilterOperator.STARTSWITH, FilterOperator.EQ],
        },
        {
            fieldName: DkvCustomerNumberField.NAME,
            filterOperators: [FilterOperator.CONTAINS, FilterOperator.STARTSWITH, FilterOperator.EQ],
        },
    ];

    return (
        <>
            <ExTable<DkvCustomerNumber, IdListRequest>
                queryHook={useOrganizationDKVCustomerNumberListQuery}
                additionalRequestParams={{
                    id: organizationId,
                }}
                columnDefs={getColumnDefs(t)}
                filterDefs={filterDefs}
                title={t("organizations_dkvCustomerNumbers")}
                keyFieldName={DkvCustomerNumberField.DKV_CUSTOMER_NUMBER}
                renderActions={(keys) => (
                    <>
                        {hasPermission(PermissionLevel.MANAGER) && keys.length === 0 && (
                            <Tooltip title={t("action_createDKVCustomerNumber")}>
                                <IconButton disabled={isCreateDialogOpen} onClick={() => setIsCreateDialogOpen(true)}>
                                    <AddCircleIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </>
                )}
            />
            <DKVCustomerNumberCreateDialog
                open={isCreateDialogOpen}
                onClose={() => setIsCreateDialogOpen(false)}
                organizationId={organizationId}
            />
        </>
    );
}
